import { render, staticRenderFns } from "./DeleteConsideration.vue?vue&type=template&id=4a490a8a&scoped=true"
import script from "./DeleteConsideration.vue?vue&type=script&lang=js"
export * from "./DeleteConsideration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a490a8a",
  null
  
)

export default component.exports